import React, { useEffect, useState } from "react";
import { useAppSelector } from "@/redux-config/hooks";
import { selectUser } from "@/redux-config/entities/user";
import { Helmet } from "react-helmet";
import { CustomBreadCrumb } from "@/components/customBreadCrumb";
import { CustomInput, CustomPagination, CustomTable, PaginationText } from "@/components";
import { FileSignature, Info, Trash } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { RoleApi } from "@/api";
import { selectLanguage } from "@/redux-config/entities/language";
import { useAppPagination } from "@/Router/hook";
import { RoleType } from "@/DTO";
import { InsideLoading } from "@/components/loading/inside";
import { ConvertDate, ConvertNumber } from "@/utils";
import { SearchComponent } from "@/components/search";


export const RolesList: React.FC<{}> = () => {

  const { t } = useTranslation();

  const crumbs = [
    { name: t("Dashboard"), href: "/" },
    { name: t("Roles"), href: "#" }
  ];

  const navigate = useNavigate();
  const lang = useAppSelector(selectLanguage);
  const user = useAppSelector(selectUser);
  const [loading, setLoading] = useState<boolean>(true);
  const [pagination, setPagination] = useState(useAppPagination());

  const [data, setData] = useState<RoleType[]>([]);
  const [searchData, setSearchData] = useState<string>();
  const handleGetData = (page: number) => {
    setLoading(true);
    RoleApi.GetRoleList(user, { ...pagination, currentPage: page }, searchData).then((data) => {
      setData(data.data);
      setPagination(data.pagination);
      setLoading(false);
    }).catch((err) => {

      setLoading(false);
    });
  };

  useEffect(() => {
    handleGetData(pagination.currentPage);
  }, []);


  return (
    <>
      <Helmet>
        <title>MahdiBookShop | Role List</title>
        <meta name="description" content="Basic example" />
      </Helmet>
      <div className="d-flex flex-column">
        <CustomBreadCrumb breadCrumbList={crumbs} />
        <div className="w-100 p-2">
          <div className="rounded-3 py-2 bg-custom-white h-100 d-flex flex-column justify-content-between">
            <div className={"d-flex flex-row gap-2 align-items-center"}>
              <h5 className={"p-3"}>{t("RoleList")}</h5>
              <CustomInput type={"text_number"} name={"search-for-list"} placeholder={t("search") + ""}
                           className={"custom-input border-reg rounded-5"} onChange={setSearchData}
                           value={searchData} />
              <SearchComponent fetchDataApi={() => {
                handleGetData(pagination.currentPage);
              }} name={searchData} />
            </div>
            {loading ? <InsideLoading /> :
              <>
                <CustomTable
                  header={[
                    <span>{t("No")}</span>,
                    <span>{t("Name")}</span>,
                    <span>{t("RegisterDate")}</span>,
                    <span>{t("Options")}</span>
                  ]}
                  items={[
                    ...data.map((item, key) => [
                      <span>{ConvertNumber(key + 1 + (pagination.currentPage - 1) * pagination.perPage + "", lang)}</span>,
                      <span>{item.title}</span>,
                      <span>{ConvertDate(item.created_at + "", lang)}</span>,
                      <div
                        className={"d-flex flex-row gap-1 justify-content-center"}
                      >
                        <button
                          className={
                            "btn p-1 align-baseline rounded-circle bg-custom-light"
                          }
                          onClick={() => {
                            RoleApi.RemoveRole(user, item.id).then((data) => {
                              handleGetData(pagination.currentPage);
                            });
                          }}
                        >
                          <Trash />
                        </button>
                        <Link
                          to={`/roles/${item.id}`}
                          className={
                            "btn p-1 align-baseline rounded-circle bg-custom-light"
                          }
                        >
                          <Info />
                        </Link>
                      </div>
                    ])
                  ]}
                />
                <div
                  className={
                    "d-flex flex-row p-3 align-items-center justify-content-between"
                  }
                >
              <span>
                <PaginationText pagination={pagination} />
              </span>
                  <CustomPagination
                    currentPage={pagination.currentPage}
                    perPage={pagination.perPage}
                    changePage={(data: string) => {
                      navigate(`/roles?current_page=${data}`);
                      setPagination({ ...pagination, currentPage: +data });
                      handleGetData(+data);
                    }}
                    total={pagination.total}
                  />
                </div>
              </>
            }
          </div>
        </div>
      </div>
    </>
  );
};
